"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZDropDownButton = void 0;
const React = __importStar(require("react"));
const kendo_react_buttons_1 = require("@progress/kendo-react-buttons");
const LLContext_1 = require("../../languages/LLContext");
const LocalizedComponent_1 = require("../../languages/LocalizedComponent");
const kendo_react_ripple_1 = require("@progress/kendo-react-ripple");
const useLocalizedProps_1 = require("../../languages/useLocalizedProps");
const styled_components_1 = __importDefault(require("styled-components"));
const ZDropDownButtonComponent = (props) => {
    const { bgColor, textColor, items, ...buttonProps } = useLocalizedProps_1.useLocalizedProps(props);
    return (React.createElement(kendo_react_ripple_1.Ripple, null,
        React.createElement(LLContext_1.LLConsumer, null, ({ languageId }) => (React.createElement(kendo_react_buttons_1.DropDownButton, Object.assign({}, buttonProps), React.Children.map(props.children, (child, index) => React.cloneElement(child, props.localize
            ? LocalizedComponent_1.getLocalizedProps(child.props, languageId)
            : child.props)))))));
};
exports.ZDropDownButton = styled_components_1.default(ZDropDownButtonComponent) `
   & .k-button {
      &.k-primary {
         background: ${props => props.theme["app-link-color"]};
         color: ${props => props.theme["action-button-hover-text-color"]};
         &:hover {
            background: ${props => props.theme["app-link-color"]};
            color: ${props => props.theme["hover-color"]};
         }
         &:active {
            background: ${props => props.theme["app-link-color"]};
            color: ${props => props.theme["active-color"]};
         }
      }
      &:hover {
         background: ${props => props.theme["hover-color"]};
         color: ${props => props.theme["action-button-hover-text-color"]};
      }
      &:active {
         color: ${props => props.theme["active-color"]};
      }
      background: ${props => {
    if (props.disabled) {
        return props.theme["action-button-disabled-color"];
    }
    else {
        return ((props.bgColor && props.theme[props.bgColor]) ||
            props.bgColor ||
            props.theme["action-button-background-color"]);
    }
}};
      color: ${props => {
    return ((props.textColor && props.theme[props.textColor]) ||
        props.textColor ||
        props.theme["action-button-color"]);
}};
      font-weight: bold;
      font-family: ${props => props.theme["font-family"]};
   }
`;
//# sourceMappingURL=ZDropDownButton.js.map